import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { isLocalhost } from "@/utils/URL";

window.Pusher = Pusher;

let echoInstance = null;
let echoToken = null;

export const initEcho = (token, apiUrl) => {
    if (echoInstance && echoToken !== token) {
        destroyEcho();
    }
    if (echoInstance) {
        return echoInstance;
    }

    if (!token) {
        return null;
    }

    const authEndpoint = apiUrl.replace(/\/$/, "") + "/broadcasting/auth";
    const isLocal = isLocalhost();

    const wsHost = isLocal
        ? import.meta.env.VITE_REVERB_HOST || "127.0.0.1"
        : window.location.hostname;

    const wsPort = isLocal
        ? import.meta.env.VITE_REVERB_PORT
            ? Number(import.meta.env.VITE_REVERB_PORT)
            : 8081
        : 80;

    const wssPort = isLocal
        ? import.meta.env.VITE_REVERB_PORT
            ? Number(import.meta.env.VITE_REVERB_PORT)
            : 8081
        : 443;

    const forceTLS = isLocal
        ? (import.meta.env.VITE_REVERB_SCHEME ?? "http") === "https"
        : window.location.protocol === "https:";

    try {
        echoToken = token;
        echoInstance = new Echo({
            broadcaster: "reverb",
            key: import.meta.env.VITE_REVERB_APP_KEY,
            wsHost: wsHost,
            wsPort: wsPort,
            wssPort: wssPort,
            forceTLS: forceTLS,
            enabledTransports: ["ws", "wss"],
            authEndpoint: authEndpoint,
            auth: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        });
    } catch (e) {
        console.warn("Failed to initialize Echo/Pusher:", e);
        echoInstance = null;
    }

    return echoInstance;
};

export const getEcho = () => echoInstance;

export const destroyEcho = () => {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
};
